import { Exchange } from '@/types/generated/common/types'

/**
 * The currency a venue quotes in, where that is a property of the venue rather
 * than of the individual instrument. Only KRX qualifies: every KRX security is
 * priced in won, so a marquee chip or badge can answer the question from the
 * exchange alone instead of resolving an instrument per item.
 *
 * `undefined` means "not venue-wide" — ask the instrument, or assume USD.
 */
export function venueQuoteCurrency(exchange: Exchange): string | undefined {
  return exchange === Exchange.EXCHANGE_XKRX ? 'KRW' : undefined
}

/**
 * Symbol to print in front of a price quoted in `quoteCurrency`.
 *
 * A deliberately short allow-list with a `$` default, not `Intl.NumberFormat`'s
 * currency mode: every venue we trade quotes in USD or a USD stablecoin except
 * KRX, whose shares are quoted in won. `$` for anything unknown or unresolvable
 * is exactly the behaviour that shipped, so this can only ever stop a non-USD
 * price from claiming to be dollars — it can't blank out an existing one.
 */
const PRICE_PREFIX_BY_CURRENCY: Record<string, string> = {
  KRW: '₩',
}

export function pricePrefix(quoteCurrency: string | null | undefined): string {
  return PRICE_PREFIX_BY_CURRENCY[quoteCurrency?.toUpperCase() ?? ''] ?? '$'
}
